import { Conductor } from "src/models";
import { ArchiveList, ArchiveListInitialState, ReduxAction } from "../models";
import { ArchiveListTypes } from "../types";

export const ArchiveListState = (state: ArchiveList = ArchiveListInitialState, action?: ReduxAction): ArchiveList => {
    if (!action) return state;

    switch (action.type) {
        case ArchiveListTypes.SHOW_ARCHIVE_LIST_LOADING:
        case ArchiveListTypes.REQUEST_LOAD_ARCHIVE_LIST:
            const clear = action.payload && action.payload.clearBeforeFetch;
            return { ...state, loading: true, list: clear ? [] : state.list, firstLoad: false };
        case ArchiveListTypes.HIDE_ARCHIVE_LIST_LOADING:
            return { ...state, loading: false, firstLoad: false };
        case ArchiveListTypes.SET_SEARCH_TEXT:
            return { ...state, searchText: action.payload };
        case ArchiveListTypes.SET_ARCHIVE_LIST_DATA:
            const data: { list: Conductor[], clear: boolean, count: number, totalRecords: number } = action.payload;

            let list = [...state.list];

            if (data.clear) {
                list = [...data.list];
            }
            else {
                data.list.forEach((x) => {
                    const sameDate = list.find((y) => y.date === x.date);

                    if (!sameDate) {
                        list = [...list, x];
                        return;
                    }

                    sameDate.items = [...sameDate.items, ...x.items];
                });
            }

            const offset = (data.clear ? 0 : state.offset) + (data.list.length > 0 ? data.count : 0);

            return {
                ...state,
                list,
                offset,
                count: data.count,
                totalRecords: data.totalRecords,
                loading: false
            };

    }

    return state;
};
